import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function PyqsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to home page resources section with PYQ tab active
    navigate("/#resources?tab=pyq", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-10 h-10 text-[#b48c36] animate-spin" />
        <p className="text-slate-400 font-bold text-[10px] uppercase tracking-[0.4em]">Redirecting to Archives...</p>
      </div>
    </div>
  );
}

